import { LineProps, Line as VdsLine } from "@vds/lines";

const Line = ({ ...rest }: LineProps) => {
  return <VdsLine {...rest} />;
};

export default Line;
